import { IsNotEmpty } from "class-validator";

export default class DeleteCompanyReq {
  @IsNotEmpty({
    message: "",
  })
  readonly companyId: number;

  constructor(arg: any) {
    arg = arg || {};
    this.companyId = arg.companyId;
  }
}
